import { Component, EventEmitter, inject, Input, OnInit, Output, Type } from '@angular/core';
import { FancyButtonComponent } from '../../../../common-components/fancy-button/fancy-button.component';
import { ButtonType } from '../../../../common-components/fancy-button/button-type.enum';
import { NgForOf, NgIf } from '@angular/common';
import { ImageGalleryComponent } from '../../../../common-components/popups/image-gallery/image-gallery.component';
import { PopupComponent } from '../../../../common-components/popups/popup/popup.component';
import { GalleryService } from '../../../../services/gallery.service';
import { NewImageComponent } from '../../../../common-components/popups/new-image/new-image.component';
import { ImageModel } from '../../../../models/image.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-image-view',
  standalone: true,
  imports: [
    FancyButtonComponent,
    NgForOf,
    NgIf,
    PopupComponent,
    TranslocoDirective
  ],
  templateUrl: './image-view.component.html',
  styleUrl: './image-view.component.scss'
})
export class ImageViewComponent implements OnInit {
  @Input() public images: ImageModel[] = [];
  @Output() public imagesChange: EventEmitter<ImageModel[]> = new EventEmitter<ImageModel[]>();
  @Input() public readonly: boolean = false;
  protected popupVisible: boolean = false;
  protected withBlur: boolean = false;
  protected slideInFrom: string = '';
  protected dynamicComponent: Type<any> = Object;
  protected readonly ButtonType = ButtonType;
  protected readonly maxNoOfImages = 5;
  protected showErrorMessage: boolean = false;

  private galleryService = inject(GalleryService);

  ngOnInit(): void {
    this.galleryService.imagesChanged.subscribe((images: ImageModel[]) => {
      this.images = [...images.slice(0, this.maxNoOfImages)]
      this.imagesChange.emit(this.images);
    });
  }

  protected addImage(): void {
    if (this.images.length < this.maxNoOfImages) {
      this.openNewImagePopup();
      this.imagesChange.emit(this.images)
    } else {
      this.showError(3000);
    }
    this.imagesChange.emit(this.images)
  }

  protected openGallery(i: number) {
    this.popupVisible = true;
    this.withBlur = true;
    this.slideInFrom = '';
    this.dynamicComponent = ImageGalleryComponent;
    this.galleryService.selected.next(i);
  }

  protected openNewImagePopup() {
    this.popupVisible = true;
    this.withBlur = false;
    this.slideInFrom = 'translateY(100%)';
    this.dynamicComponent = NewImageComponent;
  }

  private showError(timeout: number) {
    this.showErrorMessage = true;
    setTimeout(() => {
      this.showErrorMessage = false;
    }, timeout);
  }
}
